import React, { useEffect, useState, useMemo, useRef, createRef } from 'react';
import axios from 'axios';
import $ from 'jquery'
import OwlCarousel from 'react-owl-carousel';
import Loader from '../loader/loader_spiner';
import Player from '../Player/Player.jsx'
import { Link } from "react-router-dom";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import FadeIn from "react-lazyload-fadein";
const CarouselData = (props) => {
  const [carouselData, setprehomecarouselData] = useState([]);
  const [isLoading, setisLoading] = useState(true)
  const [playing, setPlaying] = useState(true)
  let isLiveVideo = localStorage.getItem('liveVideoPopup')
  const [isLivepopup, setisLivepopup] = useState('true');
  const [windowTopScroll, setwindowTopScroll] = useState(0);
  const [CurrentSlide, setCurrentSlide] = useState(0);
  const [loop, setloop] = useState(true)
  const [viewPort, setviewPort] = useState();

  const [Muted, setMuted] = useState(false);

  const [isShowBannerVideo, setisShowBannerVideo] = useState(true);

  const refsCarousel = useRef(0);
  useEffect(() => {
    setprehomecarouselData(props.data)
    setisLoading(false)
    props.data !== null && props.data !== undefined && props.data.length > 0 && props.data.map((data, key) => {
      if (data.slider_type === "V") {
        setloop(false)
      }
    })

    window.addEventListener('scroll', handleScroll);
    // setviewPort(parseInt(window.screen.width));
    // viewPort>767?setviewPort(200):setviewPort(850)

    setInterval(() => {
      setisLivepopup(localStorage.getItem('liveVideoPopup'));
    }, 5)
  }, [isLivepopup]);

  // useEffect(() => {
  //   setInterval(() => {
  //     setisLivepopup(localStorage.getItem('liveVideoPopup'));
  //   }, 5)
  // }, [isLivepopup]);


  // useEffect(() => {
  //   carouselData !== [] && carouselData !== null && carouselData !== undefined && carouselData.length > 0 && carouselData.map((data, key) => {
  //     if (isShowBannerVideo === true && carouselData.length > 0) {
  //       // startPosition.current = key;
  //     }
  //     else{
  //       // startPosition.current = 0;
  //     }
  //   });
  // }, [isShowBannerVideo,isLivepopup])


  const startPosition = useRef();
  const videosarrids = []

  const refsCarouselVideo = useMemo(() => {
    const refs = {}
    carouselData.map((data, key) => {
      if (data.slider_type === "V") {
        videosarrids.push(key)
        refs[key] = React.createRef(null)
      }
    })
    return refs
  }, [carouselData, videosarrids])


  const callback = (e) => {
    let CrntActv = e.currentTarget.querySelector('.owl-stage-outer').querySelector('.owl-stage').querySelector('.active').querySelector('.amma-sldr-itm')
    let selectors = '.iv'
    if (CrntActv.querySelector(selectors)) {
      let Id = parseInt(CrntActv.querySelector(selectors).getAttribute('id').split("_")[1])
      // setCurrentSlide(Id)
      startPosition.current = Id;
      let i = 0;

      videosarrids.forEach(id => {
        if (Id === id) {
          refsCarouselVideo[id].current.getInternalPlayer().play();
        } else {
          refsCarouselVideo[id].current.getInternalPlayer().pause();
        }
        i++
      });
    }
    else {
      videosarrids.forEach(id => {
        refsCarouselVideo[id].current.getInternalPlayer().pause();
      });
      CrntActv.querySelector(selectors)
    }
  }

  const handleScroll = () => {
    //setwindowTopScroll(window.scrollY);

    if (window.scrollY === 800) {
      setMuted(true);
    }
    else {
      setMuted(false);
    }
  }

  const callBackonClick = (e) => {
    let CrntActv = e.currentTarget.querySelector('.owl-stage-outer').querySelector('.owl-stage').querySelector('.active').querySelector('.amma-sldr-itm')
    let selectors = '.iv'
    if (CrntActv.querySelector(selectors)) {
      let Id = parseInt(CrntActv.querySelector(selectors).getAttribute('id').split("_")[1])
      // setCurrentSlide(Id)
      startPosition.current = Id;
      let i = 0;
      videosarrids.forEach(id => {
        //alert('carousel')
        if (Id === id) {
          //document.getElementsByTagName("video")[i].play();
          let playPromise = refsCarouselVideo[id].current.getInternalPlayer().play();
          if (playPromise !== undefined) {
            playPromise.then(_ => {
              // Automatic playback started!
              // Show playing UI.
              // We can now safely pause video...
              playPromise.pause();
            })
              .catch(error => {
                // Auto-play was prevented
                // Show paused UI.
                //alert('automaticui')
                refsCarouselVideo[id].current.getInternalPlayer().play()
              });
          } else {
            refsCarouselVideo[id].current.getInternalPlayer().play()
          }
        } else {
          //document.getElementsByTagName("video")[id].pause();
          refsCarouselVideo[id].current.getInternalPlayer().pause();
        }
        i++
      });
    }
    else {
      //document.querySelectorAll('video').forEach(vid => vid.pause());
      videosarrids.forEach(id => {
        refsCarouselVideo[id].current.getInternalPlayer().pause();
      });
      CrntActv.querySelector(selectors)
    }
  }

  // const VolumeBlnceFun = (e) => {
  //   let element = e.currentTarget
  //   let attribute = element.getAttribute('class');
  //   if (attribute == 'spkr-btn muted') {
  //     element.classList.remove('muted')
  //   }
  //   else {
  //     element.classList.add('muted')
  //   }
  // }

  // const CarouselData = carouselData.length > 0 && carouselData.map((result, key) => {
  //   const to = result.entryid !== '' ? `/video/adds/${result.entryid}` : "";
  //   return (
  //     <Link key={key} to={to}>
  //       <div className="item" style={{ background: 'url(' + result.imgurl + ') no-repeat top center' }}>
  //         <img src={`${result.imgurl}/width=${slide_img_width}/height=${slide_img_height}/quality=100`} alt="" style={{ maxHeight: '160px', opacity: '0', width: '100%' }} />
  //       </div>
  //     </Link>
  //   )
  // });

  if (!isLoading) {
    var width = $(window).width();
    var slide_img_width;
    var slide_img_height;

    if (width > 1100 && width < 1920) {
      slide_img_width = 1920;
      slide_img_height = 1080;
    }
    if (width > 1920 && width < 5500) {
      slide_img_width = 1920;
      slide_img_height = 1080;
    }
    else if (width > 768 && width < 1000) {
      slide_img_width = 768;
      slide_img_height = 432;
    }
    else if (width > 318 && width < 768) {
      slide_img_width = 600;
      slide_img_height = 338;
    }
    else {
      slide_img_width = 1920;
      slide_img_height = 1080;
    }

    const responsiveView = {
      320: { nav: false },
      480: { nav: false },
      600: { nav: false },
      960: { nav: true }
    }

    return (
      <>
        <div className={`row carouselWrapper ${loop === true ? 'h-auto' : ''}`} ref={refsCarousel}>
          <OwlCarousel
            className="bnnr-sldr"
            mouseDrag={true}
            loop={loop}
            //autoplayHoverPause={true}
            smartSpeed={600}
            autoplay={loop}
            dots={true}
            nav={true}
            autoplayTimeout={5000}
            onClick={callBackonClick}
            onLoad={callback}
            startPosition={startPosition.current}
            // onChange={({ item, page }) => {
            //   startPosition.current = item.index - page.size;
            // }}
            navText={['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>']}
            items={1}
            responsive={responsiveView}
          >

            {
              carouselData !== null && carouselData !== undefined && carouselData.length > 0 && carouselData.map((data, key) => {
                const mainlink = data.parent_entryid !== "" ? `/video/cat/slider/${data.parent_entryid}` : "";
                const to = data.entryid !== "" ? `/video/play/${data.entryid}` : "";
                if (data.slider_type === "V") {
                  if (data.cookies && data.cookies !== 'null' && data.cookies !== 'undefined') {
                    var downloadUrlCookie =
                      "?Key-Pair-Id=" +
                      data.cookies["CloudFront-Key-Pair-Id"] +
                      "&Policy=" +
                      data.cookies["CloudFront-Policy"] +
                      "&Signature=" +
                      data.cookies["CloudFront-Signature"];
                  }
                }

                return (
                  <div className="amma-sldr-itm" key={key}>
                    <div className={`vido-wppr ${loop === true ? 'h-auto' : ''}`} key={key}>
                      {data.slider_type === "I" ? <span className='d-block w-100'>
                        {
                          data.entryid === '' ?
                            <div className='placeholder hor'>
                              <img
                                src={`${data.imgurl}`}
                                alt="" key={key}

                                className="w-100 transition"
                              />
                            </div>

                            : <Link to={data.entryid !== "" ? `/video/cat/slider/${data.entryid}` : ''}>
                              <div className='placeholder hor'>
                                <img
                                  src={`${data.imgurl}`}
                                  alt="" key={key}

                                  className="w-100 transition"
                                />
                              </div>
                            </Link>
                        }
                      </span> :
                        <>
                          <div className="iv" id={`vidowpprid_${key}`}>
                            {/* <div className="thumb" id={`imageid_${key}`} ref={refsByImage[key]}>
                              <img src={data.thumburl.h_thumburl} alt="" />
                            </div> */}
                            {/* <div className="player" id={`playerid_${key}`} ref={refsByVideo[key]}> */}
                            <div className="player" id={`playerid_${key}`} >
                              {/* <iframe src={data.downloadurl} allow="autoplay">
                              <Player playerref={refsCarouselVideo[key]} playing={true} videoUrl={data.downloadurl} downloadUrlcookie={downloadUrlcookie} cookie={data.cookies} volume={localStorage.getItem('reactplayer.volume')?localStorage.getItem('reactplayer.volume'):1} />
                            </iframe> */}
                              <Player parent_entryid={data.parent_entryid} playerref={refsCarouselVideo[key]}
                                // playing={playing} 
                                videoUrl={data.downloadurl} downloadUrlcookie={downloadUrlCookie} cookie={data.cookies} isMuted={Muted} volume={localStorage.getItem('reactplayer.volume') ? localStorage.getItem('reactplayer.volume') : 1} />
                            </div>
                          </div>
                        </>
                      }
                    </div>
                  </div>
                  // <Link to={mainlink}>
                  //   <div className="amma-sldr-itm" key={key}>
                  //     <div className="vido-wppr" key={key}>
                  //       {data.slider_type === "I" ? <span>
                  //         <img
                  //           src={`${data.imgurl}/width=${slide_img_width}/height=${slide_img_height}/quality=100`} />
                  //       </span> :
                  //         <>
                  //           <div className="iv" id={`vidowpprid_${key}`}>
                  //             <div className="player" id={`playerid_${key}`} >
                  //               <Player playerref={refsCarouselVideo[key]} playing={playing} videoUrl={data.downloadurl} downloadUrlcookie={downloadUrlCookie} cookie={data.cookies} volume={localStorage.getItem('reactplayer.volume') ? localStorage.getItem('reactplayer.volume') : 1} />
                  //             </div>
                  //           </div>
                  //         </>
                  //       }
                  //     </div>
                  //   </div>
                  //  </Link>
                )
                // return (
                //   <>
                //     <div className="bnnr-sldr-itm" key={key}>
                //       <div className="sldr-bx">
                //         <div className="vdo-bx">
                //           <video loop="true" autoplay="autoplay" muted>
                //             <source src={item.link} type="video/mp4" />
                //           </video>
                //           <div className="vdo-mutd-btn">
                //             <button type="button" className="spkr-btn" onClick={VolumeBlnceFun}>
                //               <i class="fa fa-volume-up" aria-hidden="true"></i>
                //               <i class="fa fa-volume-off" aria-hidden="true"></i>
                //             </button>
                //           </div>
                //         </div>
                //         <div className="thumb" id={`imageid_${key}`} ref={refsByImage[key]}>
                //           <img src={result.imgurl} alt="" />
                //         </div>
                //       </div>
                //     </div>
                //   </>
                // )
              })
            }
          </OwlCarousel>
        </div>
      </>
    );
  } else {
    return (<>
      <Loader />
    </>)
  }

}
export default CarouselData;